import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate, TextFormat } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity } from './vehicle-position.reducer';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const VehiclePositionDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const vehiclePositionEntity = useAppSelector(state => state.vehiclePosition.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="vehiclePositionDetailsHeading">
          <Translate contentKey="fleetSenseApp.vehiclePosition.detail.title">VehiclePosition</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{vehiclePositionEntity.id}</dd>
          <dt>
            <span id="created">
              <Translate contentKey="fleetSenseApp.vehiclePosition.createdDate">Created</Translate>
            </span>
          </dt>
          <dd>
            {vehiclePositionEntity.created ? (
              <TextFormat value={vehiclePositionEntity.created} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="latitude">
              <Translate contentKey="fleetSenseApp.vehiclePosition.latitude">Latitude</Translate>
            </span>
          </dt>
          <dd>{vehiclePositionEntity.latitude}</dd>
          <dt>
            <span id="longitude">
              <Translate contentKey="fleetSenseApp.vehiclePosition.longitude">Longitude</Translate>
            </span>
          </dt>
          <dd>{vehiclePositionEntity.longitude}</dd>
          <dt>
            <Translate contentKey="fleetSenseApp.vehiclePosition.truckImplement">Truck Implement</Translate>
          </dt>
          <dd>{vehiclePositionEntity.truckImplement ? vehiclePositionEntity.truckImplement.licensePlate : ''}</dd>
          <dt>
            <Translate contentKey="fleetSenseApp.vehiclePosition.company">Company</Translate>
          </dt>
          <dd>{vehiclePositionEntity.company ? vehiclePositionEntity.company.name : ''}</dd>
          <dt>
            <Translate contentKey="fleetSenseApp.vehiclePosition.user">User</Translate>
          </dt>
          <dd>{vehiclePositionEntity.user ? vehiclePositionEntity.user.login : ''}</dd>
        </dl>
        <Button tag={Link} to="/vehicle-position" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/vehicle-position/${vehiclePositionEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default VehiclePositionDetail;
